
// let csrfToken = '';

export const setCSRFToken = (token) => {
  console.log(`Setting csrf to ${token}`); 
  // csrfToken = token;
  // const name = "csrftoken";
  // console.log(`all cookies ${document.cookie}`)
  // const value = document.cookie.split("; ").find(row => row.startsWith(name + "="));
  // return value ? value.split("=")[1] : "";
}

export const getCSRFToken = () => {
  //return csrfToken;
  const name = "csrftoken";
  console.log(`all cookies ${document.cookie}`)
  const value = document.cookie.split("; ").find(row => row.startsWith(name + "="));
  return value ? value.split("=")[1] : "";
}